import { Box, Typography } from "@mui/material";
import { useState } from "react";
import { connect } from "react-redux";
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

const RapHousieManagment = (props) => {

    const navigate = useNavigate();
    const location = useLocation();
    const pathname = location.pathname;
    const state = location.state;
    console.log("location : ", location);
    console.log("location.pathname : ", pathname);
    console.log("location.state : ", state);
    const [loader, setLoader] = useState(false);

    return (
        // <div style={{
        //         flex: 1,
        //         width: "100%",
        //         height: "100vh",
        //         background:'green',
        //         padding:4,
        //         display: "flex",
        //         flexDirection: "column",
        //         boxSizing: "border-box"
        //     }}>

        // </div>
        <Box sx={{
            flex: 1,
            height: '100%',
            display: "flex",
            padding: 0,
            flexDirection: "column",
            gap: 0,
            //overflow: "auto",
            overflow: "hidden",
        }}>
            <h2>Rap Housie Management</h2>
            <Outlet />
        </Box>
    );
}

const mapStateToProps = (state) => {
    return {

    }
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(RapHousieManagment)